import { StorageKey, StorageValue } from './types';

export abstract class BaseStorage {
  private readonly storage: Storage = null;

  protected constructor(storage: Storage) {
    this.storage = storage;
  }

  protected get(key: StorageKey): StorageValue {
    if (this.isStorageSupported()) {
      const storageValue: string | null = this.storage.getItem(key);
      if (storageValue !== null) {
        return JSON.parse(storageValue);
      }
    }

    return null;
  }

  protected set(key: StorageKey, value: StorageValue): boolean {
    if (this.isStorageSupported()) {
      this.storage.setItem(key, JSON.stringify(value));
      return true;
    }
    return false;
  }

  protected remove(key: StorageKey): boolean {
    if (this.isStorageSupported()) {
      this.storage.removeItem(key);
      return true;
    }
    return false;
  }

  private isStorageSupported(): boolean {
    return Boolean(this.storage);
  }
}
